import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { apiDocsTranslationRef } from '@backstage/plugin-api-docs';

export const apiDocsTranslations = createTranslationResource({
  ref: apiDocsTranslationRef,
  translations: {
    'pt-BR': () => import('./pt-BR'),
    en: () => import('./en'),
  },
});